module.exports = __webpack_public_path__ + "2ca7c121055d23a2939b1fac68f936d5.ogg";